export default {
  init() {
    // JavaScript to be fired on the about us page
      $('#dateFilter li').on('click', function() {
          const year = $(this).data('year')
          $('input[name=date]').val(year)
          $('#filters').submit()
      })

      $('#regionFilter li').on('click', function() {
        const year = $(this).data('region')
        $('input[name=region]').val(year)
        $('#filters').submit()
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/news.js